
/**
* There will be one reducer file per page / common component
*/
import { GET_USERPROFILE_SUCCESS, GET_USERPROFILE_FAILURE, GET_USERPROFILE } from '../actions';

const initialState = {
    displayName: '',
    emailId: '',
    employeeRole: '',
    firstName: '',
    lastName: '',
    managerEmail: '',
    managerFirstName: '',
    managerLastName: '',
    networkId: '',
    salesStructure: [],
    sapID: 0,
    statusCode: 0,
    statusMessage: '',
    uid: 0
};

const UserProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERPROFILE:
            return {
                ...state,
            };
        case GET_USERPROFILE_SUCCESS:
            return {
                ...state,
                ...action.data
            };
        case GET_USERPROFILE_FAILURE:
            return {
                ...state,
                ...initialState, ...action.data,
            };
        default: {
            return { ...state };
        }
    }
};

export default UserProfileReducer;
